module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-05.2c68b84c.jpg";